module.exports = __webpack_public_path__ + "static/media/2-1.4e76bec3.png";